import React from 'react';
import { motion } from 'framer-motion';

const Header = () => {
  return (
    <div className="bg-white">
      <motion.header 
        className="relative h-[70vh] bg-cover bg-center flex items-center justify-center text-white mt-6 overflow-hidden"
        style={{ backgroundImage: "url('/images/Personal_Logo.png')" }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        {/* Overlay oscuro */}
        <div className="absolute inset-0 bg-black/50"></div>

        {/* Logo transparente arriba izquierda */}
        <div className="absolute top-2 left-2 z-20">
         <img 
  src="/images/fe5.png" 
  alt="Logo Element5" 
  className="h-24 md:h-32 object-contain mix-blend-multiply"
/> 
        </div>

        {/* Contenido principal */}
        <div className="relative z-10 text-center max-w-4x1 px-6">
          <motion.h1 
  className="text-4xl md:text-6xl font-extrabold mb-6 leading-tight"
  initial={{ y: 35, opacity: 0 }}
  animate={{ y: 0, opacity: 1 }}
  transition={{ delay: 0.3, duration: 0.8 }}
>
  SOLUCIONES QUÍMICAS <br />
  APLICADAS PARA LA CONSTRUCCIÓN
</motion.h1>

<motion.p 
className="text-xl md:text-2xl font-medium mb-8"
  initial={{ y: 30, opacity: 0 }}
  animate={{ y: 0, opacity: 1 }}
  transition={{ delay: 0.6, duration: 0.8 }}
>
  <span className="text-white font-extrabold">
    +10 años
  </span>{" "}
  de experiencia en aditivos químicos para concreto y construcción.
</motion.p>



          <motion.div 
            className="flex flex-col sm:flex-row gap-4 justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.9, duration: 0.8 }}
          >
            <a 
              href="" 
              className="bg-white text-red-600 font-bold px-6 py-3 rounded-lg shadow hover:bg-gray-200 transition"
            >
              BIENVENIDOS
              <a href='https://element5.mx' target='_blank' className='hover:underline'></a>
            </a>
            <a 
              href="https://element5.mx" 
              className="bg-red-600 text-white font-bold px-6 py-3 rounded-lg shadow hover:bg-red-700 transition"
            >
              Pagina Web→
              <a href='https://element5.mx' target='_blank' className='hover:underline'></a>
            </a>
          </motion.div>
        </div>
      </motion.header>
    </div>
  );
};

export default Header;